



import Vue from 'vue';
import util from '@/utils';
import { Component, Prop } from 'vue-property-decorator';
declare var window: any;
declare var $: any;
@Component({})
export default class Download extends Vue {
  @Prop({ type: Object, default: {} }) form: any;
  @Prop({ type: Boolean, default: false }) isEncParam: any;
  @Prop({ type: String, default: '' }) downloadApi: any;
  // 二次验证
  private secondary = true;

  private onExport() {
    if (this.secondary) {
      this.secondary = false;
      try {
        const f: any = {};
        for (let k in this.form) {
          if ((this.form as any)[k]) {
            f[k] = (this.form as any)[k];
          }
        }
        const opts = this.isEncParam ? util.encParam(f) : f;
        // 动态创建元素
        const iframe = document.createElement('iframe');
        document.body.appendChild(iframe);
        let src =
          process.env.VUE_APP_API + this.downloadApi + '?' + $.param(opts);
        iframe.setAttribute('id', this.downloadApi);
        (window.frames[this.downloadApi] as any).src = src;

        setTimeout(() => {
          document.body.removeChild(iframe);
          this.secondary = true;
        }, 30000);
      } catch (err) {
        this.$message.warning(err.message);
        this.secondary = true;
      }
    }
  }
}
